<template lang="pug">
    .car-configurator
        .car-label(v-if="!fullScreen && !isIframeMode", :style="{backgroundColor: fullScreen ? '#fff' : 'transparent'}") НОВЫЙ <span>Volkswagen {{carModel | capitalize}}</span>
        .car-scene(:style="configuratorStyle")
            three-js-scene(v-if="this.configuratorHeight > 0",
              :width="sceneWidth",
              :height="sceneHeight",
              @points="onCameraPoints",
              @modelloaded="isModelLoaded=true", ref="scene")
            u-s-p-info(:height="this.sceneHeight", :showDefaultUsp="!isUspWindowVisible" v-if="!isMobile")
            u-s-p-info(:height="this.sceneHeight", :showDefaultUsp="false" v-else-if="isMobileUnlocked && uspWindowVisible")
            u-s-p-info-mobile(v-for="cameraPoint in cameraPoints",
                v-if="uspData && ((isMobile && !isUspWindowVisible) || (!isMobile)) && cameraPoint.name === uspData.pointName",
                :key="cameraPoint.name",
                :point="cameraPoint"
                @click="isMobileUnlocked = true")
            zoom-controll(v-show="isModelLoaded")
            options-menu(v-show="isModelLoaded", :uspWindowVisible="isUspWindowVisible")
        fullscreen-dialog(v-if="false")
</template>
<script>
import OptionsMenu from "./CarConfigurator/OptionsMenu";
import ZoomControll from "./CarConfigurator/ZoomControll";
import FullscreenDialog from "./CarConfigurator/FullscreenDialog";
import USPInfo from "./CarConfigurator/USPInfo";
import {mapGetters} from "vuex";
import ThreeJsScene from "./CarConfigurator/ThreeJsScene";
import USPInfoMobile from "./CarConfigurator/USPInfoMobile";
import isMobileMixin from "./mixins/isMobileMixin";

export default {
  mixins: [isMobileMixin],
  name: 'CarConfigurator',
  components: {USPInfoMobile, ThreeJsScene, USPInfo, FullscreenDialog, ZoomControll, OptionsMenu},
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  data() {
    return {
      sceneWidth: 0,
      sceneHeight: 0,
      configuratorHeight: 0,
      loadedPerscents: 0,
      isModelLoaded: false,
      isMobileUnlocked: false,
      cameraPoints: [],
      mobileHeight: 0
    }
  },

  mounted() {
    window.addEventListener('resize', this.onWindowResize)
    // setInterval(() => {
    //   this.updateSliderHeight()
    // }, 100)
    this.updateSliderHeight()
  },

  destroyed() {
    window.removeEventListener('resize', this.onWindowResize)
  },

  watch: {
    uspData() {
      this.isMobileUnlocked = false
    },
    uspWindowVisible(visible) {
      if (!visible) this.isMobileUnlocked = false
    },
    isModelLoaded() {
      this.$nextTick(() => {
        this.updateSliderHeight()
      })
    },
    fullScreen() {
      setTimeout(() => {
        this.updateSliderHeight()
      }, 100)
    }
  },

  computed: {
    ...mapGetters(['uspWindowVisible', 'uspData', 'fullScreen', 'isIframeMode', 'carModel']),
    isUspWindowVisible() {
      if (this.isMobile) {
        return this.isMobileUnlocked && this.uspWindowVisible
      }

      return this.uspWindowVisible
    },
    configuratorStyle() {
      return {
        height: this.configuratorHeight.toFixed(2) + 'px',
        backgroundColor: '#000'
      }
    }
  },

  methods: {
    onWindowResize() {
      this.updateSliderHeight()
    },

    updateSliderHeight() {
      const siteHeaderEl = document.querySelector('#site-header')
      const showRoomLabelEl = document.querySelector('.car-configurator .car-label')
      const testDriveEl = document.querySelector('.info-section')
      const menuEl = document.querySelector('.options-menu')

      const headerHeight = siteHeaderEl ? siteHeaderEl.getBoundingClientRect().height : 0
      const labelHeight = showRoomLabelEl ? showRoomLabelEl.getBoundingClientRect().height : 0
      const testDriveHeight = testDriveEl.getBoundingClientRect().height
      const menuHeight = menuEl.getBoundingClientRect().height;

      // console.log('headerHeight', headerHeight);
      // console.log('labelHeight', labelHeight);
      // console.log('testDriveHeight', testDriveHeight);
      // console.log('menuHeight', menuHeight);

      this.configuratorHeight = this.fullScreen ? window.innerHeight - (labelHeight ) : window.innerHeight - (headerHeight + labelHeight)

      if (this.fullScreen || this.isIframeMode) this.configuratorHeight -= testDriveHeight

      this.sceneHeight = this.configuratorHeight

      // console.log(window.innerHeight)

      //if (!this.isMobile) {
      this.sceneHeight -= menuHeight
      // }

      this.sceneHeight += 'px'

      // if (this.isMobile && this.mobileHeight === 0) {
      //   this.mobileHeight = window.innerHeight
      // } else if (this.isMobile) {
      //   this.configuratorHeight = this.fullScreen ? this.mobileHeight - (labelHeight) : this.mobileHeight - (headerHeight + labelHeight)
      //   this.sceneHeight = this.configuratorHeight - optionsMenuHeight + 'px'
      // }

      if (this.isMobile) {
        this.sceneWidth = '100%'
      } else {
        this.sceneWidth = window.innerWidth - document.querySelector('.usp-info').getBoundingClientRect().width + 'px'
      }

      this.$refs.scene?.onWindowResize()
    },

    onCameraPoints(points) {
      this.cameraPoints = points
    }
  }
}
</script>